module.exports = __webpack_public_path__ + "static/img/cneQrCode.bef4ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cneQrCode.jpg
// module id = myRm
// module chunks = 1